import { OdataManager } from '@/api/odata/odata-manager';
import { Marka } from '@/api/model/interfaces';

export default class MarkaOdata extends OdataManager<Marka> {}
